import { render, staticRenderFns } from "./mailObserver.vue?vue&type=template&id=d2ca0afc"
import script from "./mailObserver.vue?vue&type=script&lang=js"
export * from "./mailObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports